// extracted by mini-css-extract-plugin
export default {"wrapper":"unloadingExcel_wrapper__dVMmc"};